<template>
  <div
    v-if="contentBlock"
    :class="['content-block-container', 'edit', contentBlock.key]"
  >
    <a class="af-icons af-icons-edit" @click.prevent="redirect(editUrl)"></a>
    <content-block
      :content-block="contentBlock"
      :model-name="modelName"
      :model-id="modelId"
    />
  </div>
  <div v-else :class="['content-block-container', 'new', contentBlockKey]">
    <a class="af-icons af-icons-edit" @click.prevent="redirect(newUrl)"></a>
  </div>
</template>

<script>
import Storage from '@/lib/storage.js';
import ContentBlock from './ContentBlock';

export default {
  components: {
    ContentBlock
  },
  props: {
    contentBlockKey: {
      type: String,
      required: true
    },
    contentBlock: {
      type: Object,
      default: null
    },
    modelName: {
      type: String,
      default: null
    },
    modelId: {
      type: Number,
      default: null
    }
  },
  computed: {
    newUrl() {
      if (this.modelName && this.modelId) {
        return `/content/block/new?concerns=${this.modelName}&id=${this.modelId}&key=${this.contentBlockKey}`;
      }

      return `/content/block/new?key=${this.contentBlockKey}`;
    },
    editUrl() {
      return `/content/block/${this.contentBlock.slug}`;
    }
  },
  methods: {
    redirect(url) {
      const storage = new Storage();
      storage.createCookie('redirect_after_submit', window.location.href, 1);
      window.location.href = url;
    }
  }
};
</script>
